export enum ContentSource {
  DX = 'dx',
  NAME = 'cmspages_content_source',
  Ribbons = 'ribbons',
}
